module.exports = __webpack_public_path__ + "static/media/Message-Record-Hub.7606317f.svg";